import React, { useState, useEffect } from 'react';
import {
    Link,
    useLocation,
    useHistory,
} from 'react-router-dom';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { promoCodeAdded, promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';
import { classAdded, scrollSelector } from '../../../../store/reducers/scrollReducer';
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import ErrorMessage from './error/ErrorMessage';

function PromotionCodeLarge({ companyInfo }) {
    const scroll = useSelector(scrollSelector); 
    const promoCode = useSelector(promoCodeSelector);
    const dispatch = useDispatch()
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [scrollClass, setScrollClass] = useState(scroll);
    const [promotionCode, setPromotionCode] = useState(promoCode.code);
    const summary = params?.get("summary");
    let history = useHistory();
    const [fromSummary, setfromSummary] = useState(false);

    useEffect(() => {
        setPromotionCode(promoCode.code);
        if(summary) {
            setfromSummary(summary);
        }
    }, []); // eslint-disable-line

    useEffect(() => {
        setTimeout(function(){ setScrollClass("progression_container large") ; }, 10);
    }, []); // eslint-disable-line

    function onSubmit(data, event) {
        dispatch(pathAdded(history.location.pathname));
        dispatch(promoCodeAdded(data.promoCode));
        dispatch(classAdded("progression_container large startBottom"));
        history.push("/form/summary");    
    };
    
    function setClass() {
        dispatch(classAdded("progression_container large startTop"))
    };

    return (
        <>
            <Link to="/form/secondary" onClick={setClass} className="previous large">Previous <span>
                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                </svg>
            </span></Link>  
            <div className="form-choosenCompany"><span className="your-company-text">Your company:</span> {companyInfo?.name !== "" && <span>{companyInfo.name}</span>}</div> 
            <div className={scrollClass}>                
                <h2>Nomination code</h2> 
                <div className="promoCode">
                    <p>Please enter the code you received from your client. This code is used to identify the company who will request the assessment:</p>
                    <br/>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group form-promoCode">
                        <label htmlFor="promoCode">Code</label>
                        <input type="text" name="promoCode" defaultValue={promotionCode} placeholder="Enter your code"
                            {...register("promoCode", {
                                required: "Nomination code is required",
                                minLength: {
                                    value: 4,
                                    message: "Code must be longer than 3"
                                }
                            })}
                        />
                        {errors.promoCode && <ErrorMessage>{errors.promoCode.message}</ErrorMessage>}
                    </div>
                
                    <div className="button_container select">
                        <button className="nextSubmit next" type="submit" onClick={() => window.plausible('Registration Promo Code')}><span>Next</span>
                            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                            </svg>
                        </button>
                        {fromSummary && <button className="summaryNavButton" type="submit">Back to summary</button>}
                    </div>
                </form>
            </div>
        </>
    );
}

export default PromotionCodeLarge;
